import React, {useLayoutEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {eatClick, setDocumentScrollEnabled} from 'Util/Utilities';
import './style.css';

export type LegacyPortalDialogProps = {
  [key: string]: any;
  className?: string;
  style?: any;
  disableScroll?: boolean;
  result?: (button: number) => void;
  hideOverlay?: boolean;
  children?: any;
};

const LegacyPortalDialog = (props: LegacyPortalDialogProps) => {
  const [rootElement] = useState(document.createElement('div'));
  const disableScroll = !!props.disableScroll;

  useLayoutEffect(() => {
    document.body.appendChild(rootElement);
    disableScroll && setDocumentScrollEnabled(false);

    return () => {
      document.body.removeChild(rootElement);
      disableScroll && setDocumentScrollEnabled(true);
    };
  }, [rootElement, disableScroll]);

  return ReactDOM.createPortal(
    <div
      className={'ha-dialog-bg' + (props.hideOverlay ? ' ha-dialog-no-bg' : '')}
      onClick={(event: React.MouseEvent) => eatClick(event) && props.result && props.result(0)}>
      <div
        className={props.className || 'ha-dialog ha-dialog-appear vertical'}
        onClick={event => event.stopPropagation()}
        style={props.style}>
        {props.children}
      </div>
    </div>,
    rootElement,
  );
};

export default LegacyPortalDialog;
